import React, {useState} from "react";
import {Button, Card, Col, Modal, Row} from "reactstrap";
import {CommitteeMember} from "../../utils/CommitteeMember";
import "./MemberCard.css"

const MemberCard :React.FC<{member: CommitteeMember}> = ({member}) => {

    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Card style={{border: 0, marginTop: "40px", width: "300px"}} className={"parent"}>
            <table style={{height: "100%"}}>
                <tr>
                    <td valign="top">
                        <img
                            alt="..."
                            className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                            src={require("assets/img/members/" + member.image_id)}
                            style={{
                                width: "200px",
                                height: "200px",
                                objectFit: "cover",
                                borderRadius: "50%"
                            }}
                        />
                        <div className="pt-4 text-center">
                            <h5 className="title memberTitle">
                                <span className="d-block mb-1">{member.name}</span>
                                <small className="h6 text-muted">{member.role}</small>
                            </h5>

                        </div>
                    </td>
                </tr>
                <tr>
                    <td valign="bottom">
                        {member.details && <Button
                            color="primary"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => setModalOpen(true)}
                        >
                            More Info
                        </Button>}
                    </td>
                </tr>
            </table>


            {member.details && <Modal
                size="xl"
                className="modal-dialog-centered"
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
            >
                <div className="modal-body">
                    <Row>
                        <Col sm={"4"}>
                            <img
                                alt="..."
                                className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                src={require("assets/img/members/" + member.image_id)}
                                style={{
                                    width: "200px",
                                    height: "200px",
                                    objectFit: "cover",
                                    borderRadius: "50%"
                                }}
                            />
                            <div className="pt-4 text-center">
                                <h5 className="title">
                                    <span className="d-block mb-1">{member.name}</span>
                                    <small className="h6 text-muted">{member.role}</small>
                                </h5>
                            </div>
                            <span style={{fontSize: "14px"}}>{member.details.aboutMe}</span>
                        </Col>
                        <Col className={"modalDetails"}>
                            {member.details.areaOfResearch &&
                                <>
                                    <h5>Area(s) of research</h5>
                                    {member.details?.areaOfResearch}
                                </>
                            }
                            <h5>What I love about Computing</h5>
                            {member.details?.whatILoveAboutComputing}
                            <h5>Why I Joined</h5>
                            {member.details.whyIJoined}
                            {member.details.inspiration &&
                                <>
                                    <h5>Who inspires me</h5>
                                    {member.details.inspiration}
                                </>
                            }
                            <h5>A fun fact about me</h5>
                            {member.details.funFact}
                        </Col>
                    </Row>
                </div>
                <div className="modal-footer">
                    <Button
                        color="secondary"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setModalOpen(false)}
                    >
                        Close
                    </Button>
                </div>
            </Modal>}
        </Card>
    )
}

export default MemberCard;
